export default __webpack_public_path__ + "static/media/CSRealCase2-en.1f13675e.jpg";